import React from "react";

//pages:
import TrackPage from "./TrackPage";
import MediaItemPage from "./MediaItemPage";
import Review from "./Review";
import ProfilePage from "./Profile";
import AdminPanel from "./AdminPanel";
import {Layout} from "../../_metronic/layout";
import HomePage from "./Homepage";

const Dashboard = ({page, lastPath, ...props}) => {
    return (
        <Layout {...props}>
            {page === "homepage" ? <HomePage /> : null}
            {page === "trackPage" ? <TrackPage {...props} /> : null}

            {page === "media" ? <MediaItemPage {...props} /> : null}

            {page === "review" ? <Review {...props} /> : null}
            {page === "profile" ? <ProfilePage {...props} /> : null}
            {page === "settings" ? <AdminPanel {...props} /> : null}
        </Layout>
    );
};

export default Dashboard;
